import { render, staticRenderFns } from "./EmployerDisplayAndEdit.vue?vue&type=template&id=68190708&scoped=true&"
import script from "./EmployerDisplayAndEdit.vue?vue&type=script&lang=js&"
export * from "./EmployerDisplayAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmployerDisplayAndEdit.vue?vue&type=style&index=0&id=68190708&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68190708",
  null
  
)

export default component.exports